<template>
    <p>
        {{ data.content }}
    </p>
</template>

<script>
    export default {
        name: 'paragraph',
        props: ['data'],
    }
</script>



// WEBPACK FOOTER //
// Paragraph.vue?8ec1f774